import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import RoleService from "../../src/Services/Role.service";
const RoleLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            return RoleService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return RoleService.searchAll(search);
        },
        optionRenderer: function optionRenderer(role) {
            return _jsx("span", { children: role.name });
        },
    });
};
export default RoleLookup;
